import { PagedRequestDto } from './../paged-request.model';
export interface CorporateAdminsSearchDto extends PagedRequestDto {
  isActive?: boolean;
  isTerminated?: boolean;
  locationId?: string;
}
